import useProject from '@API/project/useProject';
import useCompareExperimentsKeys from '@shared/hooks/useCompareExperimentsKeys';
import { useParams } from 'react-router';

const useExpDetailsRouteParams = () => {
  const { experimentKeys } = useCompareExperimentsKeys();
  const { experimentKey } = useParams<{
    experimentKey?: string;
  }>();
  const { data: project } = useProject();

  return {
    experimentKey: experimentKey || experimentKeys[0],
    projectId: project?.projectId as string,
    projectName: project?.projectName as string,
    experimentKeys: experimentKeys?.length
      ? experimentKeys
      : [experimentKey as string]
  };
};

export default useExpDetailsRouteParams;
